import { render, staticRenderFns } from "./FaceDirectionMessage.vue?vue&type=template&id=f4ffe310&scoped=true&"
import script from "./FaceDirectionMessage.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionMessage.vue?vue&type=script&lang=ts&"
import style0 from "./FaceDirectionMessage.vue?vue&type=style&index=0&id=f4ffe310&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ffe310",
  null
  
)

export default component.exports